module.exports = __webpack_public_path__ + "PnxCspIcons.337be2d0813d881aa1c0.ttf";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.ttf?gea4vk
// module id = ../../../../../client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.ttf?gea4vk
// module chunks = styles